import { useAutoEmpresaId } from '../contexts/EmpresaContext';
import { clienteService, empresaService, grupoService } from '../services/entitiesServices';
import { Cliente, Empresa, Grupo } from '../types/entities';

// Hook personalizado para services com empresaId automático
export const useServicesWithEmpresa = () => {
  const { addEmpresaId, empresaId } = useAutoEmpresaId();

  return {
    // Service de clientes com empresaId automático
    clienteService: {
      ...clienteService,
      create: async (data: Partial<Cliente>) => {
        const dataWithEmpresa = addEmpresaId(data);
        return clienteService.create(dataWithEmpresa);
      },
      update: async (id: string | number, data: Partial<Cliente>) => {
        const dataWithEmpresa = addEmpresaId(data);
        return clienteService.update(id, dataWithEmpresa);
      }
    },

    // Services normais (sem necessidade de empresaId automático)
    empresaService,
    grupoService,

    // Informações do contexto
    empresaId,
    hasEmpresa: !!empresaId
  };
};

// Hook específico para criar dados com empresaId
export const useCreateWithEmpresa = () => {
  const { addEmpresaId, empresaId } = useAutoEmpresaId();

  const createCliente = async (clienteData: Partial<Cliente>) => {
    const dataWithEmpresa = addEmpresaId(clienteData);
    return clienteService.create(dataWithEmpresa);
  };

  const updateCliente = async (id: string | number, clienteData: Partial<Cliente>) => {
    const dataWithEmpresa = addEmpresaId(clienteData);
    return clienteService.update(id, dataWithEmpresa);
  };

  // Adicione aqui outros métodos conforme necessário para outros entities
  // Por exemplo: createDocumento, createApolice, etc.

  return {
    createCliente,
    updateCliente,
    empresaId,
    hasEmpresa: !!empresaId,
    addEmpresaId // Para uso manual quando necessário
  };
};